var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('md-icon',{staticClass:"chat-leadership-badge md-icon md-icon-font md-theme-default",attrs:{"title":_vm.CHAT_LEADERSHIP_BADGE_TITLE}},[_vm._v(_vm._s(_vm.CHAT_LEADERSHIP_BADGE_ICON))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }